import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 12h6l-6 8h6","key":"svg-0"}],["path",{"d":"M14 4h6l-6 8h6","key":"svg-1"}]]

/**
 * IconZzz
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItenp6Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDEyaDZsLTYgOGg2IiAvPgogIDxwYXRoIGQ9Ik0xNCA0aDZsLTYgOGg2IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/zzz
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconZzz = createReactComponent('outline', 'zzz', 'Zzz', __iconNode);

export default IconZzz;